[
  {
    "anchor": {
      "start": {
        "level": 1
      }
    },
    "key": "ef566e42-d0e0-41e2-a870-0c86e8781907",
    "order": 1,
    "slug": "welcome",
    "sourcePath": "@grapheme-slides/levels/simplified/001/001.gen.js"
  },
  {
    "anchor": {
      "before": {
        "glyph": "丨"
      }
    },
    "key": "d2f8e263-7d5d-41ec-9f69-e63cd26b6e76",
    "order": 2,
    "slug": "strokes",
    "sourcePath": "@grapheme-slides/levels/simplified/001/001/001.gen.js"
  },
  {
    "anchor": {
      "after": {
        "glyph": "丨"
      }
    },
    "key": "6d00b6c6-4124-49aa-afc1-66688fff89f6",
    "order": 3,
    "slug": "basic-strokes",
    "sourcePath": "@grapheme-slides/levels/simplified/001/001/003.gen.js"
  },
  {
    "anchor": {
      "before": {
        "glyph": "𠃊"
      }
    },
    "key": "1111dacf-db12-4f4e-a248-ceec6d06232f",
    "order": 4,
    "slug": "compound-strokes",
    "sourcePath": "@grapheme-slides/levels/simplified/001/002/001.gen.js"
  },
  {
    "anchor": {
      "before": {
        "glyph": "凵"
      }
    },
    "key": "09597703-338d-48ed-b674-7645f3a15a6e",
    "order": 5,
    "slug": "components",
    "sourcePath": "@grapheme-slides/levels/simplified/001/003/001.gen.js"
  },
  {
    "anchor": {
      "after": {
        "glyph": "凵"
      }
    },
    "key": "b74057f7-c390-481f-b1f4-1f28c61ca1db",
    "order": 6,
    "slug": "component-mnemonics",
    "sourcePath": "@grapheme-slides/levels/simplified/001/003/002.gen.js"
  },
  {
    "anchor": {
      "after": {
        "glyph": "山"
      }
    },
    "key": "8edbd01d-05c2-42af-aa60-9bc9a698e0ab",
    "order": 7,
    "slug": "gloss-and-alias",
    "sourcePath": "@grapheme-slides/levels/simplified/001/004/001.gen.js"
  },
  {
    "anchor": {
      "after": {
        "glyph": "一"
      }
    },
    "key": "d2c3e03d-55f9-443c-b3b5-583aec8cf310",
    "order": 8,
    "slug": "level-1/after-一/titles",
    "sourcePath": "@grapheme-slides/levels/simplified/001/005/001.gen.js"
  },
  {
    "anchor": {
      "before": {
        "glyph": "二"
      }
    },
    "key": "7367b55c-4689-45e5-a62a-f444f4324464",
    "order": 9,
    "slug": "multiple",
    "sourcePath": "@grapheme-slides/levels/simplified/001/006/001.gen.js"
  },
  {
    "anchor": {
      "after": {
        "glyph": "三"
      }
    },
    "key": "26f8723e-262a-4071-b784-ed50224949ff",
    "order": 10,
    "slug": "four",
    "sourcePath": "@grapheme-slides/levels/simplified/001/007/001.gen.js"
  },
  {
    "anchor": {
      "after": {
        "glyph": "干"
      }
    },
    "key": "2f5c0504-963f-441c-adc0-c95449b93757",
    "order": 11,
    "slug": "pinyin-initials",
    "sourcePath": "@grapheme-slides/levels/simplified/001/011/001.gen.js"
  },
  {
    "anchor": {
      "after": {
        "glyph": "土"
      }
    },
    "key": "2222df1b-5be1-48c1-bffa-d94623ad94ed",
    "order": 12,
    "slug": "level-1/after-土/same-decomposition",
    "sourcePath": "@grapheme-slides/levels/simplified/001/013/001.gen.js"
  },
  {
    "anchor": {
      "before": {
        "glyph": "岸",
        "card": {
          "kind": "pronunciation",
          "pinyin": "an4"
        }
      }
    },
    "key": "eea0ef1e-8f58-46da-8bb0-68c8f1f89361",
    "order": 16,
    "slug": "pinyin",
    "sourcePath": "@grapheme-slides/levels/simplified/001-P1/001/001.gen.js"
  },
  {
    "anchor": {
      "after": {
        "glyph": "岸",
        "card": {
          "kind": "pronunciation",
          "pinyin": "an4"
        }
      }
    },
    "key": "7ed1b468-3283-4b72-83c0-8c277c0bf4a3",
    "order": 17,
    "slug": "falling-tone",
    "sourcePath": "@grapheme-slides/levels/simplified/001-P1/001/004.gen.js"
  },
  {
    "anchor": {
      "after": {
        "glyph": "干",
        "card": {
          "kind": "pronunciation",
          "pinyin": "gan4"
        }
      }
    },
    "key": "49375a14-c586-4ad9-8492-fad88553dc3a",
    "order": 18,
    "slug": "familiar-initials",
    "sourcePath": "@grapheme-slides/levels/simplified/001-P1/002/001.gen.js"
  },
  {
    "anchor": {
      "before": {
        "glyph": "干",
        "card": {
          "kind": "pronunciation",
          "pinyin": "gan1"
        }
      }
    },
    "key": "0a39f5a3-9965-40aa-863a-ec43819ce7cb",
    "order": 19,
    "slug": "polyphonic-characters",
    "sourcePath": "@grapheme-slides/levels/simplified/001-P1/003/001.gen.js"
  },
  {
    "anchor": {
      "after": {
        "glyph": "干",
        "card": {
          "kind": "pronunciation",
          "pinyin": "gan1"
        }
      }
    },
    "key": "8af5a335-a64b-44ee-8d10-9cf0e8a2a81e",
    "order": 20,
    "slug": "high-tone",
    "sourcePath": "@grapheme-slides/levels/simplified/001-P1/003/002.gen.js"
  },
  {
    "anchor": {
      "after": {
        "glyph": "一",
        "card": {
          "kind": "pronunciation",
          "pinyin": "yi1"
        }
      }
    },
    "key": "45b9b52e-05d0-4e1e-89db-3c8e65f541c6",
    "order": 21,
    "slug": "y-in-finals",
    "sourcePath": "@grapheme-slides/levels/simplified/001-P1/005/001.gen.js"
  },
  {
    "anchor": {
      "after": {
        "glyph": "二",
        "card": {
          "kind": "pronunciation",
          "pinyin": "er4"
        }
      }
    },
    "key": "cb59f1a7-ba20-40e8-acca-7596da91c9f2",
    "order": 22,
    "slug": "the-final-er",
    "sourcePath": "@grapheme-slides/levels/simplified/001-P1/006/001.gen.js"
  },
  {
    "anchor": {
      "after": {
        "glyph": "山",
        "card": {
          "kind": "pronunciation",
          "pinyin": "shan1"
        }
      }
    },
    "key": "976a9c7c-e4d3-45de-9299-820de43f37df",
    "order": 23,
    "slug": "ch-sh-zh-initials",
    "sourcePath": "@grapheme-slides/levels/simplified/001-P1/008/001.gen.js"
  },
  {
    "anchor": {
      "start": {
        "level": 2
      }
    },
    "key": "7f80f739-fafd-4856-bfc2-c79525d8ee0c",
    "order": 24,
    "slug": "level-2/han",
    "sourcePath": "@grapheme-slides/levels/simplified/002/001.gen.js"
  },
  {
    "anchor": {
      "after": {
        "glyph": "非"
      }
    },
    "key": "c43f4eac-4de2-45c4-b133-465dd59a9234",
    "order": 25,
    "slug": "level-1/after-非/pronunciation",
    "sourcePath": "@grapheme-slides/levels/simplified/018/001/001.gen.js"
  },
  {
    "anchor": {
      "after": {
        "glyph": "厅"
      }
    },
    "key": "37ead7d7-49a0-44bb-9780-eda8eca32cac",
    "order": 26,
    "slug": "level-1/after-厅/multi-component-decomposition",
    "sourcePath": "@grapheme-slides/levels/simplified/018/003/001.gen.js"
  }
]
